import OverviewPage from 'components/admin/OverviewPage.vue';

const adminOverviewRoutes = [
    { path: 'participants', name: 'participants-overview', component: OverviewPage },
    { path: 'education', name: 'education-overview', component: OverviewPage },
    { path: 'library', name: 'library-overview', component: OverviewPage },
    { path: 'settings', name: 'settings-overview', component: OverviewPage },
    { path: 'development', name: 'development-overview', component: OverviewPage },
    { path: 'tables', name: 'tables-overview', component: OverviewPage },

    { path: 'participants/modulePay', name: 'payments-overview', component: OverviewPage },
    { path: 'settings/requests', name: 'settings-requests-overview', component: OverviewPage },
    { path: 'settings/logs', name: 'logs-overview', component: OverviewPage },
    { path: 'library/site', name: 'site-overview', component: OverviewPage },
    { path: 'courses/:packageId/:id/digit-trace', name: 'course-digit-trace-overview', component: OverviewPage },
];

export default adminOverviewRoutes;
